import React from 'react';
import TextEditorContainer from './TextEditorContainer';
import CommentsContainer from './CommentsContainer';
import styled from 'styled-components';

export const CorrespondenceTabLayout = styled.div`
  margin-top: 1rem;
  padding: 1rem 2rem 1rem 1rem; /* top right bottom left  */
  background-color: ${({ theme }) => theme.colors.White};
`;

export const CorrespondenceTabContent = styled.div`
  font-size: ${({ theme }) => theme.fontSize.m};
`;

const CorrespondenceTabContainer = () => {
  return (
    <CorrespondenceTabLayout>
      <CorrespondenceTabContent>
        <TextEditorContainer />
        <CommentsContainer />
      </CorrespondenceTabContent>
    </CorrespondenceTabLayout>
  );
};

export default CorrespondenceTabContainer;
